import { Select } from "antd";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { IStep } from "../../models/courses.model";

interface IProps {
  levelCode?: number;
  setLevelCode: (levelCode: number) => void;
  data?: IStep[];
  eduStepCode?: string;
};

const LevelSelect: FC<IProps> = ({
  levelCode,
  setLevelCode,
  data = [],
  eduStepCode,
}) => {
  const { t } = useTranslation();

  const getLevelOptions = () => {
    const levels = eduStepCode
      ? data?.filter((item: any) => item.eduStepCode === eduStepCode)
      : data;
    return levels?.map((item: any) => (
      <Select.Option
        key={item.courseCode}
        value={item.courseCode}
      >
        {item.courseName}
      </Select.Option>
    ));
  };

  return (
    <Select
      placeholder={t('student.student.column26')}
      value={levelCode}
      onChange={setLevelCode}
    >
      <Select.Option value="">
        {t('common.text.all')}
      </Select.Option>
      {getLevelOptions()}
    </Select>
  );
};

export default LevelSelect;